module.exports = __webpack_public_path__ + "img/discord.309e3388.svg";